import { createSelector } from "reselect";
import { State } from "../../../redux/state";

export const resellerRoot = (state: State) => state.reseller;

export const resellersSelector = createSelector(resellerRoot, (reseller) =>
  reseller.ids.map((id) => reseller.entities[id])
);
